/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    /**
     * <h3>数字增减条</h3>
     * <a href="../../ui_controls/bui.number.html" target="_blank">demo</a>
     * <p>可以设置一个区域,常用于购物车</p>
     * <h5>方法</h5>
     * {{#crossLink "bui.number/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.number/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.number/value"}}{{/crossLink}}: 不传参则获取,传参则设置 <br>
     * {{#crossLink "bui.number/disabled"}}{{/crossLink}}: 禁止输入修改 <br>
     *  @namespace bui
     *  @class number
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]  
     *  @param {number} [option.min] [最小值]  
     *  @param {number} [option.max] [最大值]  
     *  @param {number} [option.step] [一次增加多少]  
     *  @param {string} [option.value] [初始值]  
     *  @param {boolean} [option.disabled] [ 是否可以输入修改 false | true ]  
     *  @param {boolean} [option.render] [ 是否动态填充, true | false  ]  
     *  @param {boolean} [option.tips] [ 超出是否显示提醒 ]  
     *  @param {function} [option.callback] [ 点击按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="number" class="bui-number"></div>
     *      
     *   js: 
     *   
            // 初始化
            var uiNumber = bui.number({
                            id:'#number'
                });
                //获取值
                uiNumber.value(); 
     *
     *
     */
    ui.number = function(option){

        //默认配置
        var config = {
            id: null,
            min: 0,
            max: 100,
            step: 1,
            value: 0,
            disabled: false,
            render: true,
            tips: true,
            prev: ".bui-number-prev",
            input: "input",
            next: ".bui-number-next",
            callback: null
        }

        //方法
        var module = {
            disabled: disabled,
            value: getValue,
            prev: prev,
            next: next,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.number, option );
        
        var id ,
            max,
            min,
            step,
            islockPlus = false ,  //是否可以点击
            islockMinus = false ,  //是否可以点击
            //控件自定义模板可以自由绑定想增加或者减少的按钮名称
            $prev,
            $next,
            $input,
            $id ;
        
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            max = option.max;
            min = option.min;
            step = option.step;

            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("number id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            //render = true,就会动态创建模板
            if( option.render ){
                render(option);
            }

            $prev = option.prev.indexOf("#") > -1 ? ui.obj(option.prev): $id.children(option.prev);
            $next = option.next.indexOf("#") > -1 ? ui.obj(option.next): $id.children(option.next);
            $input = option.input.indexOf("#") > -1 ? ui.obj(option.input): $id.children(option.input);

            //绑定按钮事件
            bind(option);
            

            if( min > max ){
                ui.hint('min值 不能大于 max值 ');
                return;
            }

            //禁止修改
            if( option.disabled ){
                $input.attr({'disabled':'disabled'});
            }
            //设置初始值
            set( option.value );
            
            return this;
        }

        //模板
        function template (option) {
            
            var html = '';
                html += '    <div class="bui-number-prev">-</div>';
                html += '    <input type="text" value="0"/>';
                html += '    <div class="bui-number-next">+</div>';

            return html;
        };

        //渲染
        function render (option) {

            var tpl = template(option) ;

            $id.html(tpl);

            return this;
        };



        //绑定事件
        function bind (option) {
            //检测输入的值是否有效
            $input.on('input',function (e) {
              var val = isNaN( parseInt($(this).val()) ) ? 0: parseInt($(this).val());

                if( /^[0-9]*$/i.test(val) ){
                    set( val );
                }

              e.stopPropagation();

            })

            //点击减少
            $prev.on('click.bui',function (e) {
              prev();
              option.callback && option.callback.call(this,e,module);
            })

            //点击增加
            $next.on('click.bui',function (e) {
              next();
              option.callback && option.callback.call(this,e,module);
            })

            return this;
        }
        
        //获取值
        function get () {

            var value =  parseInt($input.val());

            return value;
        };

        //设置值
        function set (num) {
            
            value = num || 0;

            if( value > max ){
                value = max;

                if( param.tips ){
                    ui.hint("输入的值大于最大值");
                }

                islockMinus = false;
                islockPlus = true;
            }

            if( value < min ){
                value = min;

                if( param.tips ){
                    ui.hint("输入的值小于最小值");
                }
                islockMinus = true;
                islockPlus = false;
            }
            
            if( value >= min && value <= max ){
                value = value;

            }

            $input.val( parseInt(value) );

            return this;
        };

        /**
         * 设置或者获取值
         *  @method value
         *  @chainable
         *  @param {string} [num] [设置值]
         *  @example 
            
            //设置值
            uiNumber.value("110");

            //获取值
            uiNumber.value();
                
         */
        function getValue (num) {
            var val = 0;
            if( num ){
                set (num);

                val = num;
            }else{
                val = get();
            }
            return val;
        }

        /**
         * 禁止输入
         *  @method disabled
         *  @chainable
         *  @param {boolean} [bool] [禁止输入 true | false]
         *  @example 
            
            //获取值
            uiNumber.disabled();
                
         */
        function disabled (bool) {

            var bool = bool == false ? false: true;
            if( bool ){

                $input.attr({'disabled':'disabled'});
            }else{
                $input.removeAttr('disabled');
            }
            return this;
        }

        /**
         * 设置或者获取值
         *  @method prev
         *  @chainable
         *  @example 

            //下一步的值
            uiNumber.prev();
                
         */
        function prev () {
          
          if( !islockMinus ){
            var data = $input.val();
            var num = parseInt(data);
            if( num > min ){
                var total = num -= step ;
                num = total > min ? total: min;

            }else{
                num = min;
            }

            set(num);

          }

          return this;

        }
        /**
         * 设置或者获取值
         *  @method next
         *  @chainable
         *  @example 

            //下一步的值
            uiNumber.next();
                
         */
        function next () {
          if( !islockPlus ){

            var data = $input.val();

            var num = parseInt(data);

            if( num < max ){
                var total = num += step ;
                num = total < max ? total: max;
                
            }else{
                num = max;
            }

            set( num );

          }

          return this;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiNumberWidget = uiNumber.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiNumber.option();

            //获取某个参数
            var id = uiNumber.option( "id" );

            //修改一个参数
            uiNumber.option( "min",10 );

            //修改多个参数
            uiNumber.option( {"min":10} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;
    };

    return ui;

})( bui || {}, libs );
